





















import { Component, Mixins } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import UserInquiry from '@/ts/UserInquiry';

@Component
export default class QuestionsView extends Mixins(LocalizationMethods) {
    constructor() {
        super();
    }

    get activeCategory() {
        return this.$store.getters['HomeAssistant/getActiveCategory'];
    }

    get inquiries(): UserInquiry[] {
        return this.$store.getters['UserTicketsAttributes/getCategoryInquiries'](this.activeCategory.id);
    }

    public changeView(inquiry: UserInquiry) {
        this.$store.commit(Mutations.SET_ACTIVE_HOME_ASSISTANT_INQUIRY, inquiry);
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_ANSWER_VISIBILITY, true);
    }
}
